import { apiClient } from '@core/api/ApiClientFactory';

export interface LineTrackerRelationData {
    elementName: string;
    count: number;
}

export const lineTrackerService = {
    /**
     * Load line tracker relations data
     */
    async loadRelations(
        deviceId: string,
        moduleId: string,
        start: string,
        end: string
    ): Promise<LineTrackerRelationData[]> {
        try {
            console.log(`[LineTrackerService] Loading relations for module: ${moduleId}`);
            const response = await apiClient.get<LineTrackerRelationData[]>(
                `statistics/linetracker/relations/${deviceId}/${moduleId}/${start}/${end}`
            );
            console.log(`[LineTrackerService] Relations data loaded:`, response.data);
            return response.data;
        } catch (error) {
            console.error('[LineTrackerService] Error loading relations:', error);
            throw error;
        }
    }
};
